<template>
  <div class="room-extend-menu-section-component">
    <div class="room-extend-menu-section">
      <div class="room-extend-menu-section-header">
        <button class="room-extend-menu-section-button back" 
                @click="$emit('onChangeSection', 'chat')" />
        <p class="room-extend-menu-section-title">{{ title }}</p>
      </div>
      <div class="room-extend-menu-section-body">
        <div class="h-full overflow-y-auto">
          <RoomNotice v-show="isNoticeSection"/>
          <RoomRecord v-show="isRecordSection" :newWindow="newWindow"/>
          <RoomFile v-show="isFileSection"/>
          <RoomMeetingNote v-show="isMeetingNoteSection"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import RoomNotice from "@/components/Room/ExtendMenu/RoomNotice/RoomNotice";
import RoomRecord from "@/components/Room/ExtendMenu/RoomRecord/RoomRecord";
import RoomFile from "@/components/Room/ExtendMenu/RoomFile/RoomFile";
import RoomMeetingNote from "@/components/Room/ExtendMenu/RoomMeetingNote/RoomMeetingNote.vue";

export default {
  name: 'RoomExtendMenuSection',
  components: {
    RoomNotice,
    RoomRecord,
    RoomFile,
    RoomMeetingNote,
  },
  props: {
    section: String,
    newWindow:{
      type: Boolean,
      default: false,
    }  
  },
  computed: {
    title() {
      switch (this.section) {
        case 'notice':
          return this.$t('extendMenu.section.notice')
        case 'file':
          return this.$t('extendMenu.section.file')
        case 'record':
          return this.$t('extendMenu.section.record')
        case 'meetingNote':
          return this.$t('extendMenu.section.note')
        default:
          return ''
      }
    },
    isNoticeSection(){
      return this.section == 'notice'
    },
    isRecordSection(){
      return this.section == 'record'
    },
    isFileSection(){
      return this.section == 'file'
    },
    isMeetingNoteSection(){
      return this.section == 'meetingNote'
    },
  },
}
</script>

<style lang="scss" scoped>
.room-extend-menu-section-component {}
.room-extend-menu-section {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.room-extend-menu-section-header {
  height: 48px;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.room-extend-menu-section-button {
  &.back {
    width: 44px;
    height: 100%;
    background: url('~@/assets/images/arrowLineThickLeft_gray.svg') no-repeat center / 14px auto;
    position: absolute;
    left: 0;
    &:hover {
      background: url('~@/assets/images/arrowLineThickLeft.svg') no-repeat center / 14px auto;
    }
  }
}
.room-extend-menu-section-title {
  font-size: 13px;
  font-weight: 700;
}
.room-extend-menu-section-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
</style>